/* CreateQuestionComponent.js */

"use strict";
const Renderer = require("./CreateQuestionRenderer");
const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CreateQuestionComponent extends BaseCreateComponent {
    constructor(logger, sitePaths, selectedSite, title, message) {
        super(
            logger,
            title || "Create Device - Please specify device name" + (sitePaths.length ? " and an associated site" : ""),
            message,
            "Enter Device Name"
        );
        this._sitePaths = sitePaths;
        this._selectedSite = selectedSite;
        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._sitePaths = undefined;
                this._selectedSite = undefined;
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "BaseCreateComponent.shutdown() error");
            }
        );
    }

    createAction(name, site) {
        this._context.resolve({ name: name, site: site });
    }

    cancelAction() {
        this._context.reject({ userRejected: true });
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
      this._context = context;
    }
}
module.exports = CreateQuestionComponent;
